(function () {
  const grid = document.querySelector('#product-grid');
  const paginationWrapper = document.querySelector('.pagination-wrapper');

  if (!grid || !paginationWrapper) return;

  const lastPageLink = paginationWrapper.querySelector('.pagination__item:last-of-type');
const totalPages = lastPageLink ? parseInt(lastPageLink.getAttribute('href')?.match(/page=(\d+)/)?.[1] || 99) : 99;
  let currentPage = 1;
  let loading = false;
  let done = false;

  // Hide pagination
  paginationWrapper.style.display = 'none';

  // Create spinner
  const spinner = document.createElement('div');
  spinner.id = 'infinite-scroll-spinner';
  spinner.style.cssText = 'text-align:center;padding:40px 0;display:none;';
  spinner.innerHTML = `<span style="display:inline-block;width:28px;height:28px;border:2px solid #ccc;border-top-color:#000;border-radius:50%;animation:pp-spin .8s linear infinite"></span>`;
  paginationWrapper.parentNode.insertBefore(spinner, paginationWrapper);

  // Add spinner keyframe
  const style = document.createElement('style');
  style.textContent = `@keyframes pp-spin { to { transform: rotate(360deg); } }`;
  document.head.appendChild(style);

  async function loadMore() {
    if (loading || done) return;
    loading = true;
    spinner.style.display = 'block';

    const nextPage = currentPage + 1;
    const url = `${window.location.pathname}?page=${nextPage}`;

    try {
      const res = await fetch(url);
      const text = await res.text();
      const doc = new DOMParser().parseFromString(text, 'text/html');
      const newItems = doc.querySelectorAll('#product-grid li.grid__item');

      if (newItems.length === 0 || nextPage > totalPages) {
        done = true;
        spinner.style.display = 'none';
        return;
      }

      newItems.forEach(item => grid.appendChild(item));
      currentPage = nextPage;

      if (currentPage >= totalPages) {
        done = true;
      }

    } catch (e) {
      console.error('Infinite scroll error:', e);
    }

    loading = false;
    spinner.style.display = 'none';
  }

  // Scroll trigger
  window.addEventListener('scroll', function () {
    if (loading || done) return;
    const threshold = document.body.scrollHeight - window.innerHeight - 400;
    if (window.scrollY >= threshold) loadMore();
  });

})();